import Constanta, { jobApplySteps } from '../../config/constanta';
import DatePicker from 'react-date-picker';
import Helper from '../../lib/helper';
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import RichTextEditor from 'react-rte';
import moment from 'moment';

import { ActionCreators } from '../../actions';
import { config } from '../../config/config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import Alert from '../../components/alert';

import '../../styles/job-detail.css';
import '../../styles/job-apply.css';
import '../../styles/stepper.css';

const fieldBorderError = { border: "1px solid #ff0000"};

const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
        {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
        {label: 'Italic', style: 'ITALIC'},
        {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_BUTTONS: [
        {label: 'UL', style: 'unordered-list-item'},
        {label: 'OL', style: 'ordered-list-item'}
    ]
};

class JobApply extends Component {
    constructor(props) {
        super(props);
        this.validatePerStep = false;

        this.state = {
            rte:{
                experiences: [{
                    jobDesc: RichTextEditor.createEmptyValue(),
                    projects: [{
                        projDesc: RichTextEditor.createEmptyValue(),
                        roleAchievement: RichTextEditor.createEmptyValue()
                    }]
                }]
            },
            isAlertError: false,
            job: {},
            applicant:{
                vacancyId: "",
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                currentAddress: "",
                birthDate: null,
                isEmployed: false,
                skills: "",
                linkedin:"",
                onlinePortfolio: "",
                employments: [
                    JSON.parse(JSON.stringify(Constanta.employment))
                ],
                educations: [
                    JSON.parse(JSON.stringify(Constanta.education))
                ],
                location: "",
                salary: 0,
                noticePeriod: Constanta.noticePeriod.IMMEDIATELY,
                reasonLeaving: "",
                referral: Constanta.referral.WEBSITE,
                referralOther: "",
                termsAndConditions: false,
                reCaptcha: "",
            },
            cvFile: {},
            idFile: {},
            steppers:[
                {
                    step: Constanta.application_step.PERSONAL,
                    name: "Personal Information",
                    complete: false,
                    fields: [
                        "firstName", "lastName", "email", "phoneNumber", "currentAddress", "birthDate", "skills"
                    ]
                },
                {
                    step: Constanta.application_step.EXPERIENCES,
                    name: "Experiences",
                    complete: false,
                    fields: [
                        "companyName", "jobTitle", "jobDesc", "salary", "periodStart"
                    ],
                    fieldsProject: [
                        "periodStart", "periodEnd", "techs", "description", "roles"
                    ]
                },
                {
                    step: Constanta.application_step.EDUCATION,
                    name: "Educations",
                    complete: false,
                    fieldsUniv: [
                        "university", "major", "periodStart", "periodEnd", "gpa", "final"
                    ],
                    fieldsOther: [
                        "certificateName", "receivedDate"
                    ]
                },
                {
                    step: Constanta.application_step.ADDITIONAL,
                    name: "Additional Information",
                    complete: false,
                    fields: [
                        "location", "salary", "noticePeriod", "reasonLeaving", "referral"
                    ]
                }
            ],
            activeStep: Constanta.application_step.PERSONAL,
            errors: []
        }
    }

    // async componentWillMount(){
    //     let job_param = this.props.location.job;

    //     if(job_param){
    //         this.setState(prevState => ({
    //             ...prevState,
    //             job: job_param,
    //             applicant : {
    //                 ...prevState.applicant,
    //                 vacancyId: job_param.id,
    //                 location: job_param.jobLocationIds[0]
    //             }
    //         }))
    //     }
    //     else{
    //         await this.props.jobFunction();
    //         await this.props.jobLocation();
    //         await this.props.jobType();
    //         this.props.vacancyBySlugAction(this.props.match.params.slug).then(() => {
    //             if(this.props.vacancyBySlug){
    //                 let j = this.props.vacancyBySlug;

    //                 if(j.jobFunctionId  && this.props.jobFunctions)
    //                     j.jobFunction = this.props.jobFunctions.find(x => x.id === j.jobFunctionId);
    //                 if(j.jobTypeId && this.props.jobTypes)
    //                     j.jobType = this.props.jobTypes.find(x => x.id === j.jobTypeId);
    //                 if(j.jobLocationIds && this.props.jobLocations)
    //                     j.jobLocations = this.props.jobLocations.filter(x => this.props.jobLocations.map(l => l.id).indexOf(x.id) > -1);

    //                 this.setState(prevState => ({
    //                     ...prevState,
    //                     job: j,
    //                     applicant : {
    //                         ...prevState.applicant,
    //                         vacancyId: j.id,
    //                         location: j.jobLocationIds[0]
    //                     }
    //                 }))
    //             }
    //         })
    //     }
    // }

    async componentDidMount() {
        let job_param = this.props.location.job;

        if(job_param) {
            this.setState(prevState => ({
                ...prevState,
                job: job_param,
                applicant : {
                    ...prevState.applicant,
                    vacancyId: job_param.id
                }
            }));
        } else {
            const jFunc = await this.props.jobFunction();
            const jLoc = await this.props.jobLocation();
            const jType = await this.props.jobType();
            const vacancyDetail  = await this.props.vacancyBySlugAction(this.props.match.params.slug);

            if(vacancyDetail){
                let j = vacancyDetail;

                if(j.jobFunctionId && jFunc)
                    j.jobFunction = jFunc.find(x => x.id === j.jobFunctionId);
                if(j.jobTypeId && jType)
                    j.jobType = jType.find(x => x.id === j.jobTypeId);
                if(j.jobLocationIds && jLoc)
                    j.jobLocations = jLoc.filter(x => jLoc.map(l => l.id).indexOf(x.id) > -1);

                this.setState(prevState => ({
                    ...prevState,
                    job: j,
                    applicant : {
                        ...prevState.applicant,
                        vacancyId: j.id
                    }
                }));
            }
        }
    }

    checkError(){
        let error = [];

        if(this.validatePerStep) {
            if(this.state.activeStep === Constanta.application_step.PERSONAL){
                error = [ ...error, this.validateInformation()];
            } else if(this.state.activeStep === Constanta.application_step.EXPERIENCES){
                error = [ ...error, this.validateExperiences()];
            } else if(this.state.activeStep === Constanta.application_step.EDUCATION){
                error = [ ...error, this.validateEducation()];
            } else if(this.state.activeStep === Constanta.application_step.ADDITIONAL){
                error = [ ...error, this.validateAdditional()];
            }
        } else {
            error = [
                ...this.validateInformation(),
                ...this.validateExperiences(),
                ...this.validateEducation(),
                ...this.validateAdditional()
            ];
        }

        this.setState(prevState => ({
            ...prevState,
            errors: error
        }))

        return error;
    }

    validateInformation() {
        let error = []; 

        this.state.steppers[0].fields.forEach((f, i) => {
            if(!this.state.applicant[f] || this.state.applicant[f] === "") error.push({field: f, error: "required", step: jobApplySteps.validateInformation});
        })

        if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.state.applicant.email))){
            error.push({field: "email", error: "invalid format", step: jobApplySteps.validateInformation});
        }

        return error;
    }

    validateExperiences() {
        let error = [];
        let that = this;

        if(this.state.applicant.employments !== undefined) {
            this.state.applicant.employments.forEach((e,i) => {
                this.state.steppers[1].fields.forEach((f, j) => {
                    if(f !== "jobDesc" && (!e[f] || e[f] === "")) error.push({field: f, error: "required", ei: i, step: jobApplySteps.validateExperiences});
                });
                let isEmptyJobDesc = !that.state.rte.experiences[i].jobDesc.getEditorState().getCurrentContent().hasText();
                if(isEmptyJobDesc) error.push({field: "jobDesc", error: "required", ei: i, step:jobApplySteps.validateExperiences});
                if(!e.isCurrent && (!e.periodEnd || e.periodEnd === "")) error.push({field: "periodEnd", error: "required", ei: i, step:jobApplySteps.validateExperiences});
                if(e.projects !== undefined) {
                    e.projects.forEach((p, k) => {
                        let isEmptyRoleAchievement = !that.state.rte.experiences[i].projects[k].roleAchievement.getEditorState().getCurrentContent().hasText();
                        let isEmptyProjDesc = !that.state.rte.experiences[i].projects[k].projDesc.getEditorState().getCurrentContent().hasText();

                        if(isEmptyRoleAchievement)
                            error.push({field: "roles", error: "required", ei: i, pi: k, step: jobApplySteps.validateExperiences });
                        if(isEmptyProjDesc)
                            error.push({field: "description", error: "required", ei: i, pi: k, step: jobApplySteps.validateExperiences });

                        that.state.steppers[1].fieldsProject.forEach((fp, l) => {
                            if(fp !== "description" && fp !== "roles" && (!p[fp] || p[fp] === "")) error.push({field: fp, error: "required", ei: i, pi: k, step: jobApplySteps.validateExperiences });
                        });
                    });
                }
            });
        }

        return error;
    }

    validateEducation() {
        let error = [];
        let that = this;

        if(this.state.applicant.educations !== undefined) {
            this.state.applicant.educations.forEach((e,i) => {
                if(e.type === Constanta.educationtype.UNIVERSITY){
                    that.state.steppers[2].fieldsUniv.forEach((f, j) => {
                        if(!e[f] || e[f] === "") error.push({field: f, error: "required", ei: i, step: jobApplySteps.validateEducation});
                    })

                    // eslint-disable-next-line
                    if(e.gpa && (parseInt(e.gpa) > 4 || parseInt(e.gpa) < 0 ))
                        error.push({field: "gpa", error: "GPA must be between 0 to 4", ei: i, step: jobApplySteps.validateEducation});
                }
                else{
                    that.state.steppers[2].fieldsOther.forEach((f, j) => {
                        if(!e[f] || e[f] === "") error.push({field: f, error: "required", ei: i, step: jobApplySteps.validateEducation});
                    })
                }
            });
        }
        return error;
    }

    validateAdditional() {
        let error = []; 

        this.state.steppers[3].fields.forEach((f, i) => {
            if(!this.state.applicant[f] || this.state.applicant[f] === "") error.push({field: f, error: "required", step: jobApplySteps.validateAdditional});
        })

        if(this.state.applicant.referral === Constanta.referral.EMPLOYEE || this.state.applicant.referral === Constanta.referral.OTHER){
            if(!this.state.applicant.referralOther || this.state.applicant.referralOther === "")
                error.push({field: "referralOther", error: "required", step: jobApplySteps.validateAdditional});
        }

        if(!this.state.idFile.size){
            error.push({field: "idFile", error: "required", step: jobApplySteps.validateAdditional});
        }
        if(this.state.idFile && this.state.idFile.size >= 2097152){
            error.push({field: "idFile", error: "Please choose smaller file", step: jobApplySteps.validateAdditional});
        }

        if(!this.state.cvFile.size){
            error.push({field: "cvFile", error: "required", step: jobApplySteps.validateAdditional});
        }
        if(this.state.cvFile && this.state.cvFile.size >= 2097152){
            error.push({field: "cvFile", error: "Please choose smaller file", step: jobApplySteps.validateAdditional});
        }

        if(!this.state.applicant.termsAndConditions)
            error.push({field: "termsAndConditions", error: "required", step: jobApplySteps.validateAdditional});

        if(!this.state.applicant.reCaptcha || this.state.applicant.reCaptcha === "" || this.state.applicant.reCaptcha === null)
            error.push({field: "reCaptcha", error: "required", step: jobApplySteps.validateAdditional});

        return error;
    }

    setStep(step) {
        if(this.validatePerStep) {
            let error = this.checkError();
            if(error.length === 0){
                this.setState(prevState => ({
                    ...prevState,
                    activeStep: step
                }))
            }
        } else {
            this.setState(prevState => ({
                ...prevState,
                activeStep: step
            }))
        }
    }

    submit(){
        let error = this.checkError();

        if(error.length === 0){
            let data = new FormData();
                data.append("IdFile", this.state.idFile);
                data.append("CvFile", this.state.cvFile);
                data.append("DataApplicant", JSON.stringify(this.state.applicant) );

            this.props.postApplicantAction(data).then((res) => {
                if(res){
                    setTimeout(() => {
                        this.props.push('/job/open');
                    }, 10000);
                }
            });
            this.setState({isAlertError: false});
        } else {
            this.setState({isAlertError: true});
        }
    }

    onCaptchaChange(response){
        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                reCaptcha: response
            }
        }))
    }

    addProject(index){
        let employments = this.state.applicant.employments;
            employments[index].projects.push(JSON.parse(JSON.stringify(Constanta.project)));

        let rte = {...this.state.rte};
        rte.experiences[index].projects.push({
            projDesc: RichTextEditor.createEmptyValue(),
            roleAchievement: RichTextEditor.createEmptyValue()
        });

        this.setState(prevState => ({
            ...prevState,
            rte: rte,
            applicant: {
                ...prevState.applicant,
                employments: employments
            }
        }))
    }

    addEmployment(){
        let employments = this.state.applicant.employments;
            employments.push(JSON.parse(JSON.stringify(Constanta.employment)));

        let rte = {...this.state.rte};
        rte.experiences.push({
            jobDesc: RichTextEditor.createEmptyValue(),
            projects: [{
                projDesc: RichTextEditor.createEmptyValue(),
                roleAchievement: RichTextEditor.createEmptyValue()
            }]
        });

        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                employments: employments
            }
        }))
    }

    addEducation(){
        let educations = this.state.applicant.educations;
            educations.push(JSON.parse(JSON.stringify(Constanta.education)));
        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                educations: educations
            }
        }))
    }

    deleteProject(indexproject, indexEmployment){
        let employments = this.state.applicant.employments;
            employments[indexEmployment].projects.splice(indexproject, 1);
        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                employments: employments
            }
        }))
    }

    deleteEmployment(index){
        let employments = this.state.applicant.employments;
            employments.splice(index, 1);
        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                employments: employments
            }
        }))
    }

    deleteEducation(index){
        let educations = this.state.applicant.educations;
            educations.splice(index, 1);
        this.setState(prevState => ({
            ...prevState,
            applicant: {
                ...prevState.applicant,
                educations: educations
            }
        }))
    }

    _renderModal(){
        return <div className={ (this.props.applicant_id ? "show" : "" ) + " modal fade" } tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <h2>Thank you for submitting your application.</h2>
                                <p>Our team will review your application within approximately 4-6 weeks and then contact you via email or phone.</p>
                            </div>
                            <div className="modal-footer">
                                <Link to={"/job/open"} className="gs-btn gs-btn-blue">See other vacancy</Link>
                            </div>
                        </div>
                    </div>
                </div>
    }

    render() {
        // ...this.validateInformation(),
        // ...this.validateExperiences(),
        // ...this.validateEducation(),
        // ...this.validateAdditional()
        let alertError = null;
        if(this.state.isAlertError) {
            alertError = (
                <Alert title="Required Fields" type="danger" onClose={() => {this.setState({ isAlertError: false })}}>
                    <p>Please fill these fields correctly</p>
                    {
                        this.state.errors.find(x => x.step === jobApplySteps.validateInformation) !== undefined &&
                        <React.Fragment>
                            <h5>Step Personal Information</h5>
                            <ul>
                                {this.state.errors.filter(x => x.step === jobApplySteps.validateInformation).map((err, i) => {
                                    return(
                                        <li key={i}>Field {err.field} is <span className="font-italic font-weight-bold">{err.error}</span></li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    }
                    {
                        this.state.errors.find(x => x.step === jobApplySteps.validateExperiences) !== undefined &&
                        <React.Fragment>
                            <h5>Step Experiences</h5>
                            <ul>
                                {this.state.errors.filter(x => x.step === jobApplySteps.validateExperiences).map((err, i) => {
                                    return(
                                        <li key={i}>Field {err.field} is <span className="font-italic font-weight-bold">{err.error}</span></li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    }
                    {
                        this.state.errors.find(x => x.step === jobApplySteps.validateEducation) !== undefined &&
                        <React.Fragment>
                            <h5>Step Education</h5>
                            <ul>
                                {this.state.errors.filter(x => x.step === jobApplySteps.validateEducation).map((err, i) => {
                                    return(
                                        <li key={i}>Field {err.field} is <span className="font-italic font-weight-bold">{err.error}</span></li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    }
                    {
                        this.state.errors.find(x => x.step === jobApplySteps.validateAdditional) !== undefined &&
                        <React.Fragment>
                            <h5>Step Additional Information</h5>
                            <ul>
                                {this.state.errors.filter(x => x.step === jobApplySteps.validateAdditional).map((err, i) => {
                                    return(
                                        <li key={i}>Field {err.field} is <span className="font-italic font-weight-bold">{err.error}</span></li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    }
                </Alert>
            );
        }

        return (
            <div className="job-detail">
                { this._renderModal() }
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <ul className="breadcrumb">
                                <li><Link to={"/job/open"}>Vacancies</Link></li>
                                <li>{ this.state.job.jobTitle }</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    Join DevStack as
                                </div>
                            </div>
                            <h1>{ this.state.job.jobTitle }</h1>
                            <div className="row mb-5">
                                <div className="col">
                                    <span className="job-meta">
                                        <i className="icon-directions"></i>
                                        { this.state.job.jobFunction && this.state.job.jobFunction.function }
                                    </span>
                                    <span className="job-meta">
                                        <i className="icon-location-pin"></i>
                                        { this.state.job.jobLocations && this.state.job.jobLocations.map( l => l.location ).join(", ") }
                                    </span>
                                    <span className="job-meta">
                                        <i className="icon-clock"></i>
                                        { this.state.job.jobType && this.state.job.jobType.type }
                                    </span>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col">
                                    First, tell us a bit about yourself. Fields with asterisk (*) are required.
                                </div>
                            </div>
                            {alertError}
                            <div className="row mb-5">
                                {
                                    this.state.steppers.map((s, i) => {
                                        return  <div className="col-xl-3" key={i}>
                                                    <button
                                                        onClick={ () => {this.setStep(s.step)} }
                                                        type="button"
                                                        className={ (s.step === this.state.activeStep ? 'active': '' ) + " stepper" }>
                                                        { s.name }
                                                        {
                                                            s.complete &&
                                                            <i className="icon-check"></i>
                                                        }
                                                    </button>
                                                </div>
                                    })
                                }
                            </div>
                            {
                                this.state.activeStep === Constanta.application_step.PERSONAL &&
                                <div className="row mb-5">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>First name*</label>
                                                    <input
                                                        style={this.state.errors.map(x => x.field).indexOf("firstName") > -1 ? fieldBorderError : {}}
                                                        autoFocus={true}
                                                        type="text"
                                                        value={ this.state.applicant.firstName }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    firstName: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        />
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("firstName") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "firstName").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Last name*</label>
                                                    <input
                                                        style={this.state.errors.map(x => x.field).indexOf("lastName") > -1 ? fieldBorderError : {}}
                                                        value={ this.state.applicant.lastName }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    lastName: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="text" />
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("lastName") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "lastName").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Your primary email address*</label>
                                                    <input
                                                        style={this.state.errors.map(x => x.field).indexOf("email") > -1 ? fieldBorderError : {}}
                                                        placeholder="e.g. your-name@devstack.com.au"
                                                        value={ this.state.applicant.email }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    email: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="email" />
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("email") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "email").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Your primary phone number*</label>
                                                    <input
                                                        style={this.state.errors.map(x => x.field).indexOf("phoneNumber") > -1 ? fieldBorderError : {}}
                                                        placeholder="e.g. +62-xxx-xxxx-xxxx"
                                                        value={ this.state.applicant.phoneNumber }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    phoneNumber: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="text" />
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("phoneNumber") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "phoneNumber").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col ">
                                                <div className="form-field">
                                                    <label>Current address*</label>
                                                    <textarea
                                                        style={this.state.errors.map(x => x.field).indexOf("currentAddress") > -1 ? fieldBorderError : {}}
                                                        value={ this.state.applicant.currentAddress }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    currentAddress: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        ></textarea>
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("currentAddress") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "currentAddress").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Birth date*</label>
                                                    <DatePicker
                                                        className={this.state.errors.map(x => x.field).indexOf("birthDate") > -1 ? "datepicker-error-border" : ""}
                                                        value={ this.state.applicant.birthDate }
                                                        maxDate={new Date(moment().subtract(18, 'years'))}
                                                        onChange={ (value) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    birthDate: value
                                                                }
                                                            })
                                                        }}
                                                        calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                        clearIcon={<i className='icon-close'></i>}
                                                    />
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("birthDate") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "birthDate").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Are you currently employed?*</label>
                                                    <div className="select">
                                                        <select
                                                            value={ this.state.applicant.isEmployed }
                                                            onChange={ (event) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        isEmployed: event.target.value
                                                                    }
                                                                })
                                                            }}
                                                            >
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-field">
                                                    <label>Your key skill(s)*</label>
                                                    <input
                                                        style={this.state.errors.map(x => x.field).indexOf("skills") > -1 ? fieldBorderError : {}}
                                                        placeholder="separate with comma (,) e.g. C#, Java, etc."
                                                        value={ this.state.applicant.skills }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    skills: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="text" />
                                                    <small>You can put here: architecture, web development technology, OS, programming language, database, development methodology, tool or library, etc.</small><br/>
                                                    {
                                                        this.state.errors.map(x => x.field).indexOf("skills") > -1 &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "skills").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>LinkedIn profile link</label>
                                                    <input
                                                        placeholder="e.g. https://linkedin.com/your-name"
                                                        value={ this.state.applicant.linkedin }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    linkedin: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="text" />
                                                </div>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Online Portfolio</label>
                                                    <input
                                                        placeholder="e.g. github, dribble, behance, google drive, etc"
                                                        value={ this.state.applicant.onlinePortfolio }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    onlinePortfolio: event.target.value
                                                                }
                                                            })
                                                        }}
                                                        type="text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col text-right">
                                                <button type="button" onClick={() => { this.setStep(Constanta.application_step.EXPERIENCES) }} className="gs-btn gs-btn-blue" style={{width: "auto"}}>
                                                    Next
                                                    <i className="icon-arrow-right ml-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.activeStep === Constanta.application_step.EXPERIENCES &&
                                <div className="row mb-5">
                                    <div className="col">
                                        <p>Please fill out your employment history from what your last job (or current job) to your first job</p>
                                        {
                                            this.state.applicant.employments.map( (e, i) => {
                                                return (
                                                    <div className="card mb-5" key={i}>
                                                        <div className="card-body">
                                                            {
                                                                this.state.applicant.employments.length > 1 &&
                                                                <div className="row">
                                                                    <div className="col text-right">
                                                                        <button type="button" onClick={() => { this.deleteEmployment(i) }} className="gs-btn gs-btn-pink" style={{width: "auto"}}>
                                                                            Delete Employment History
                                                                            <i className="icon-minus ml-3"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-field">
                                                                        <label>Company name*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "companyName" && x.ei === i && !x.hasOwnProperty('pi')) ? fieldBorderError : {}}
                                                                            value={ e.companyName }
                                                                            onChange={ (event) => {
                                                                                e.companyName = event.target.value;
                                                                                let employments = this.state.applicant.employments;
                                                                                    employments[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        employments: employments
                                                                                    }
                                                                                })
                                                                            }}
                                                                            type="text" />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "companyName" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "companyName" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xl-4">
                                                                    <div className="form-field">
                                                                        <label>Are you currently working here?*</label>
                                                                        <div className="select">
                                                                            <select
                                                                                value={ e.isCurrent }
                                                                                onChange={ (event) => {
                                                                                    e.isCurrent = event.target.value === "true" ? true : false;
                                                                                    if(e.isCurrent) e.periodEnd = new Date();
                                                                                    let employments = this.state.applicant.employments;
                                                                                        employments[i] = e;
                                                                                    this.setState({
                                                                                        ...this.state,
                                                                                        applicant: {
                                                                                            ...this.state.applicant,
                                                                                            employments: employments
                                                                                        }
                                                                                    })
                                                                                }}
                                                                                >
                                                                                <option value="true">Yes</option>
                                                                                <option value="false">No</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-4">
                                                                    <div className="form-field">
                                                                        <label>Start of employment*</label>
                                                                        <DatePicker
                                                                            className={this.state.errors.find(x => x.field === "periodStart" && x.step === jobApplySteps.validateExperiences && x.ei === i && !x.hasOwnProperty('pi')) ? "datepicker-error-border" : ""}
                                                                            maxDate={e.periodEnd ? new Date(new Date(e.periodEnd).setDate(new Date(e.periodEnd).getDate() - 1)) : new Date(new Date().setDate(new Date().getDate() - 1))}
                                                                            value={ e.periodStart }
                                                                            onChange={ (value) => {
                                                                                e.periodStart = value;
                                                                                e.projects.forEach(p => {
                                                                                    p.periodStart="";
                                                                                    p.periodEnd="";
                                                                                })
                                                                                let employments = this.state.applicant.employments;
                                                                                    employments[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        employments: employments
                                                                                    }
                                                                                })
                                                                            }}
                                                                            calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                            clearIcon={<i className='icon-close'></i>}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "periodStart" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodStart" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {
                                                                    !e.isCurrent &&
                                                                    <div className="col-xl-4">
                                                                        <div className="form-field">
                                                                            <label>End of employment*</label>
                                                                            <DatePicker
                                                                                className={this.state.errors.find(x => x.field === "periodEnd" && x.step === jobApplySteps.validateExperiences && x.ei === i && !x.hasOwnProperty('pi')) ? "datepicker-error-border" : ""}
                                                                                minDate={e.periodStart ? new Date(new Date(e.periodStart).setDate(new Date(e.periodStart).getDate() + 1)) : new Date(new Date().setDate(new Date().getDate() + 1))}
                                                                                value={ e.periodEnd }
                                                                                onChange={ (value) => {
                                                                                    e.periodEnd = value;
                                                                                    e.projects.forEach(p => {
                                                                                        p.periodStart="";
                                                                                        p.periodEnd="";
                                                                                    })
                                                                                    let employments = this.state.applicant.employments;
                                                                                        employments[i] = e;
                                                                                    this.setState({
                                                                                        ...this.state,
                                                                                        applicant: {
                                                                                            ...this.state.applicant,
                                                                                            employments: employments
                                                                                        }
                                                                                    })
                                                                                }}
                                                                                calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                                clearIcon={<i className='icon-close'></i>}
                                                                            />
                                                                            {
                                                                                this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                                <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Job title*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "jobTitle" && x.ei === i && !x.hasOwnProperty('pi')) ? fieldBorderError : {}}
                                                                            value={ e.jobTitle }
                                                                            onChange={ (event) => {
                                                                                e.jobTitle = event.target.value;
                                                                                let employments = this.state.applicant.employments;
                                                                                    employments[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        employments: employments
                                                                                    }
                                                                                })
                                                                            }}
                                                                            type="text" />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "jobTitle" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "jobTitle" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Net monthly salary*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "salary" && x.step === jobApplySteps.validateExperiences && x.ei === i && !x.hasOwnProperty('pi')) ? fieldBorderError : {}}
                                                                            value={ Helper.numberFormatter(e.salary) }
                                                                            onChange={ (event) => {
                                                                                e.salary = Helper.numberUnformatter(event.target.value);
                                                                                let employments = this.state.applicant.employments;
                                                                                    employments[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        employments: employments
                                                                                    }
                                                                                })
                                                                            }}
                                                                            type="text" />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "salary" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "salary" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-field">
                                                                        <label>Job description*</label>
                                                                        <RichTextEditor
                                                                            className={(this.state.errors.find(x => x.field === "jobDesc" && x.ei === i && !x.hasOwnProperty('pi'))) ? "rte-error" : ""}
                                                                            value={this.state.rte.experiences[i].jobDesc}
                                                                            onChange={ (value) => {
                                                                                let rte = { ...this.state.rte};
                                                                                rte.experiences[i].jobDesc = value;

                                                                                e.jobDesc = value.toString('html');
                                                                                let employments = this.state.applicant.employments;
                                                                                    employments[i] = e;

                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    rte: rte,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        employments: employments
                                                                                    }
                                                                                })
                                                                            }}
                                                                            toolbarConfig={toolbarConfig}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "jobDesc" && x.ei === i && !x.hasOwnProperty('pi')) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "jobDesc" && x.ei === i && !x.hasOwnProperty('pi')).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-3">
                                                                <div className="col-xl-4">
                                                                    <button type="button" className="stepper">Projects</button>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col">
                                                                    {
                                                                        e.projects.map( (p,k) => {
                                                                            return (
                                                                                <div className="card mb-3" key={k}>
                                                                                    <div className="card-body">
                                                                                        {
                                                                                            e.projects.length > 1 &&
                                                                                            <div className="row">
                                                                                                <div className="col text-right">
                                                                                                    <button type="button" onClick={() => { this.deleteProject(k, i) }} className="gs-btn gs-btn-pink" style={{width: "auto"}}>
                                                                                                        Delete project
                                                                                                        <i className="icon-minus ml-3"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                        <div className="row">
                                                                                            <div className="col-xl-6">
                                                                                                <div className="form-field">
                                                                                                    <label>Start of project*</label>
                                                                                                    <DatePicker
                                                                                                        className={this.state.errors.find(x => x.field === "periodStart" && x.ei === i && x.pi === k) ? "datepicker-error-border" : ""}
                                                                                                        minDate={e.periodStart ? new Date(e.periodStart) : new Date()}
                                                                                                        maxDate={ p.periodEnd ? new Date(new Date(p.periodEnd).setDate(new Date(p.periodEnd).getDate() - 1)) : (e.periodEnd ? new Date(e.periodEnd) : new Date()) }
                                                                                                        value={ p.periodStart }
                                                                                                        onChange={ (value) => {
                                                                                                            p.periodStart = value;
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                        calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                                                        clearIcon={<i className='icon-close'></i>}
                                                                                                    />
                                                                                                    {
                                                                                                        this.state.errors.find(x => x.field === "periodStart" && x.ei === i && x.pi === k) &&
                                                                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodStart" && x.ei === i && x.pi === k).error }</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="col-xl-6">
                                                                                                <div className="form-field">
                                                                                                    <label>End of project*</label>
                                                                                                    <DatePicker
                                                                                                        className={this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && x.pi === k) ? "datepicker-error-border" : ""}
                                                                                                        minDate={ p.periodStart ? new Date(new Date(p.periodStart).setDate(new Date(p.periodStart).getDate() + 1)) : (e.periodStart ? new Date(e.periodStart) : new Date()) }
                                                                                                        maxDate={e.periodEnd ? new Date(e.periodEnd) : new Date()}
                                                                                                        value={ p.periodEnd }
                                                                                                        onChange={ (value) => {
                                                                                                            p.periodEnd = value;
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                        calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                                                        clearIcon={<i className='icon-close'></i>}
                                                                                                    />
                                                                                                    {
                                                                                                        this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && x.pi === k) &&
                                                                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && x.pi === k).error }</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row">
                                                                                            <div className="col">
                                                                                                <div className="form-field">
                                                                                                    <label>Technologies used*</label>
                                                                                                    <input
                                                                                                        style={this.state.errors.find(x => x.field === "techs" && x.ei === i && x.pi === k) ? fieldBorderError : {}}
                                                                                                        placeholder="separate with comma (,) e.g. C#, Java, etc."
                                                                                                        value={ p.techs }
                                                                                                        onChange={ (event) => {
                                                                                                            p.techs = event.target.value;
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            })
                                                                                                        }}
                                                                                                        type="text" />
                                                                                                    {
                                                                                                        this.state.errors.find(x => x.field === "techs" && x.ei === i && x.pi === k) &&
                                                                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "techs" && x.ei === i && x.pi === k).error }</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row">
                                                                                            <div className="col-xl-6">
                                                                                                <div className="form-field">
                                                                                                    <label>Description*</label>
                                                                                                    {/* <textarea
                                                                                                        style={this.state.errors.find(x => x.field === "description" && x.ei === i && x.pi === k) ? fieldBorderError : {}}
                                                                                                        placeholder="Shortly describe about the project"
                                                                                                        value={ p.description }
                                                                                                        onChange={ (event) => {
                                                                                                            p.description = event.target.value;
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            })
                                                                                                        }}></textarea> */}
                                                                                                    <RichTextEditor
                                                                                                        className={(this.state.errors.find(x => x.field === "description" && x.ei === i && x.pi === k)) ? "rte-error" : ""}
                                                                                                        value={this.state.rte.experiences[i].projects[k].projDesc}
                                                                                                        onChange={ (value) => {
                                                                                                            let rte = { ...this.state.rte};
                                                                                                            rte.experiences[i].projects = [...this.state.rte.experiences[i].projects ];
                                                                                                            rte.experiences[i].projects[k].projDesc = value;

                                                                                                            p.description = value.toString('html');
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                rte: rte,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            });
                                                                                                        }}
                                                                                                        toolbarConfig={toolbarConfig}
                                                                                                    />
                                                                                                    <small className="form-text text-muted">Shortly describe about the project</small>
                                                                                                    {
                                                                                                        this.state.errors.find(x => x.field === "description" && x.ei === i && x.pi === k) &&
                                                                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "description" && x.ei === i && x.pi === k).error }</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="col-xl-6">
                                                                                                <div className="form-field">
                                                                                                    <label>Roles & achievements*</label>
                                                                                                    {/* <textarea
                                                                                                        style={this.state.errors.find(x => x.field === "roles" && x.ei === i && x.pi === k) ? fieldBorderError : {}}
                                                                                                        placeholder="Describe your role in project and achievement you've made in the project"
                                                                                                        value={ p.roles }
                                                                                                        onChange={ (event) => {
                                                                                                            p.roles = event.target.value;
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            })
                                                                                                        }}></textarea> */}
                                                                                                    <RichTextEditor
                                                                                                        className={(this.state.errors.find(x => x.field === "roles" && x.ei === i && x.pi === k)) ? "rte-error" : ""}
                                                                                                        value={this.state.rte.experiences[i].projects[k].roleAchievement}
                                                                                                        onChange={ (value) => {
                                                                                                            let rte = { ...this.state.rte};
                                                                                                            rte.experiences[i].projects = [...this.state.rte.experiences[i].projects ];
                                                                                                            rte.experiences[i].projects[k].roleAchievement = value;

                                                                                                            p.roles = value.toString('html');
                                                                                                            let employments = this.state.applicant.employments;
                                                                                                                employments[i].projects[k] = p;
                                                                                                            this.setState({
                                                                                                                ...this.state,
                                                                                                                rte: rte,
                                                                                                                applicant: {
                                                                                                                    ...this.state.applicant,
                                                                                                                    employments: employments
                                                                                                                }
                                                                                                            });
                                                                                                        }}
                                                                                                        toolbarConfig={toolbarConfig}
                                                                                                    />
                                                                                                    <small className="form-text text-muted">Describe your role in project and achievement you've made in the project</small>
                                                                                                    {
                                                                                                        this.state.errors.find(x => x.field === "roles" && x.ei === i && x.pi === k) &&
                                                                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "roles" && x.ei === i && x.pi === k).error }</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    <div className="row">
                                                                        <div className="col text-right">
                                                                            <button type="button" onClick={() => { this.addProject(i) }} className="gs-btn gs-btn-blue" style={{width: "auto"}}>
                                                                                Add project
                                                                                <i className="icon-plus ml-3"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className="row">
                                            <div className="col text-right">
                                                <button type="button" onClick={() => { this.addEmployment() }} className="gs-btn gs-btn-blue mr-3" style={{width: "auto"}}>
                                                    Add Employment History
                                                    <i className="icon-plus ml-3"></i>
                                                </button>
                                                <button type="button" onClick={() => { this.setStep(Constanta.application_step.EDUCATION) }} className="gs-btn gs-btn-blue" style={{width: "auto"}}>
                                                    Next
                                                    <i className="icon-arrow-right ml-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.activeStep === Constanta.application_step.EDUCATION &&
                                <div className="row mb-5">
                                    <div className="col">
                                        {
                                            this.state.applicant.educations.map( (e, i) => {
                                                return (
                                                <div className="card mb-5" key={i}>
                                                    <div className="card-body">
                                                        {
                                                            this.state.applicant.educations.length > 1 &&
                                                            <div className="row">
                                                                <div className="col text-right">
                                                                    <button type="button" onClick={() => { this.deleteEducation(i) }} className="gs-btn gs-btn-pink" style={{width: "auto"}}>
                                                                        Delete Education
                                                                        <i className="icon-minus ml-3"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="form-field">
                                                                    <label>Education type*</label>
                                                                    <div className="select">
                                                                        <select
                                                                            value={ e.type }
                                                                            onChange={ (event) => {
                                                                                // eslint-disable-next-line
                                                                                e.type = parseInt(event.target.value);
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            >
                                                                            {
                                                                                Constanta.educationtypeOption.map( o => {
                                                                                    return <option key={o.type} value={o.type}>{ o.name }</option>
                                                                                })
                                                                            }
                                                                        </select>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            e.type === Constanta.educationtype.UNIVERSITY &&
                                                            <div className="row">
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>University / institute name*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "university" && x.ei === i) ? fieldBorderError : {}}
                                                                            type="text"
                                                                            value={ e.university }
                                                                            onChange={ (event) => {
                                                                                e.university = event.target.value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "university" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "university" && x.ei === i).error }</span>
                                                                        }

                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Degree*</label>
                                                                        <div className="select">
                                                                            <select
                                                                                value={ e.degree }
                                                                                onChange={ (event) => {
                                                                                    e.degree = event.target.value;
                                                                                    let educations = this.state.applicant.educations;
                                                                                    educations[i] = e;
                                                                                    this.setState({
                                                                                        ...this.state,
                                                                                        applicant: {
                                                                                            ...this.state.applicant,
                                                                                            educations: educations
                                                                                        }
                                                                                    })
                                                                                }}>
                                                                                {
                                                                                    Constanta.degreeOption.map((d,i) => {
                                                                                        return <option key={d.degree} value={d.degree}>{ d.name }</option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            e.type === Constanta.educationtype.UNIVERSITY &&
                                                            <div className="row">
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Major*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "major" && x.ei === i) ? fieldBorderError : {}}
                                                                            type="text"
                                                                            value={ e.major }
                                                                            onChange={ (event) => {
                                                                                e.major = event.target.value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "major" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "major" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>GPA (scale of 4)*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "gpa" && x.ei === i) ? fieldBorderError : {}}
                                                                            type="number"
                                                                            min="0"
                                                                            max="4"
                                                                            value={ e.gpa }
                                                                            onChange={ (event) => {
                                                                                e.gpa = event.target.value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "gpa" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "gpa" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            e.type === Constanta.educationtype.UNIVERSITY &&
                                                            <div className="row">
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Start at*</label>
                                                                        <DatePicker
                                                                            className={this.state.errors.find(x => x.field === "periodStart" && x.ei === i && x.step === jobApplySteps.validateEducation) ? "datepicker-error-border" : ""}
                                                                            value={ e.periodStart }
                                                                            onChange={ (value) => {
                                                                                e.periodStart =value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                            clearIcon={<i className='icon-close'></i>}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "periodStart" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodStart" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Finish at*</label>
                                                                        <DatePicker
                                                                            className={this.state.errors.find(x => x.field === "periodEnd" && x.ei === i && x.step === jobApplySteps.validateEducation) ? "datepicker-error-border" : ""}
                                                                            value={ e.periodEnd }
                                                                            onChange={ (value) => {
                                                                                e.periodEnd =value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                            clearIcon={<i className='icon-close'></i>}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "periodEnd" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "periodEnd" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            e.type === Constanta.educationtype.UNIVERSITY &&
                                                            <div className="row">
                                                                <div className="col">
                                                                    <div className="form-field">
                                                                        <label>Final project topic / title*</label>
                                                                        <textarea
                                                                            style={this.state.errors.find(x => x.field === "final" && x.ei === i) ? fieldBorderError : {}}
                                                                            value={ e.final }
                                                                            onChange={ (event) => {
                                                                                e.final = event.target.value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                        ></textarea>
                                                                        {
                                                                            this.state.errors.find(x => x.field === "final" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "final" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            e.type !== Constanta.educationtype.UNIVERSITY &&
                                                            <div className="row">
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Certificate name*</label>
                                                                        <input
                                                                            style={this.state.errors.find(x => x.field === "certificateName" && x.ei === i) ? fieldBorderError : {}}
                                                                            type="text"
                                                                            value={ e.certificateName }
                                                                            onChange={ (event) => {
                                                                                e.certificateName = event.target.value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "certificateName" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "certificateName" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6">
                                                                    <div className="form-field">
                                                                        <label>Recieved date*</label>
                                                                        <DatePicker
                                                                            className={this.state.errors.find(x => x.field === "receivedDate" && x.ei === i) ? "datepicker-error-border" : ""}
                                                                            value={ e.receivedDate }
                                                                            onChange={ (value) => {
                                                                                e.receivedDate =value;
                                                                                let educations = this.state.applicant.educations;
                                                                                educations[i] = e;
                                                                                this.setState({
                                                                                    ...this.state,
                                                                                    applicant: {
                                                                                        ...this.state.applicant,
                                                                                        educations: educations
                                                                                    }
                                                                                })
                                                                            }}
                                                                            calendarIcon={<i className='icon-calendar text-blue'></i>}
                                                                            clearIcon={<i className='icon-close'></i>}
                                                                        />
                                                                        {
                                                                            this.state.errors.find(x => x.field === "receivedDate" && x.ei === i) &&
                                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "receivedDate" && x.ei === i).error }</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                )
                                            })
                                        }
                                        <div className="row">
                                            <div className="col text-right">
                                                <button type="button" onClick={() => { this.addEducation() }} className="gs-btn gs-btn-blue mr-3" style={{width: "auto"}}>
                                                    Add Education
                                                    <i className="icon-plus ml-3"></i>
                                                </button>
                                                <button type="button" onClick={() => { this.setStep(Constanta.application_step.ADDITIONAL) }} className="gs-btn gs-btn-blue" style={{width: "auto"}}>
                                                    Next
                                                    <i className="icon-arrow-right ml-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.activeStep === Constanta.application_step.ADDITIONAL &&
                                <div className="row mb-5">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-xl-4">
                                                <div className="form-field">
                                                    <label>Preferred work location*</label>
                                                    <div className="select">
                                                        <select
                                                            style={this.state.errors.find(x => x.field === "location") ? fieldBorderError : {}}
                                                            value={ this.state.applicant.location }
                                                            onChange={ (event) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        location: event.target.value
                                                                    }
                                                                })
                                                            }}
                                                            >
                                                            <option value="">Select location</option>
                                                            {
                                                                this.state.job.jobLocations ?
                                                                this.state.job.jobLocations.map((l,i) => {
                                                                    return <option key={l.id} value={l.id}>{ l.location }</option>
                                                                }) : null

                                                            }
                                                            <option value="00000000-0000-0000-0000-000000000000">Both</option>
                                                        </select>
                                                    </div>
                                                    {
                                                        this.state.errors.find(x => x.field === "location") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "location").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4">
                                                <div className="form-field">
                                                    <label>Expected salary (Net)*</label>
                                                    <input
                                                        style={this.state.errors.find(x => x.field === "salary" && x.step === jobApplySteps.validateAdditional) ? fieldBorderError : {}}
                                                        value={ Helper.numberFormatter(this.state.applicant.salary) }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    salary: Helper.numberUnformatter(event.target.value)
                                                                }
                                                            })
                                                        }}
                                                        type="text"/>
                                                    {
                                                        this.state.errors.find(x => x.field === "salary" && x.step === jobApplySteps.validateAdditional) &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "salary").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4">
                                                <div className="form-field">
                                                    <label>Notice period required*</label>
                                                    <div className="select">
                                                        <select
                                                            style={this.state.errors.find(x => x.field === "noticePeriod") ? fieldBorderError : {}}
                                                            value={ this.state.applicant.noticePeriod }
                                                            onChange={ (event) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        noticePeriod: event.target.value
                                                                    }
                                                                })
                                                            }}
                                                            >
                                                            {
                                                                Constanta.noticePeriodOption.map((n,i) => {
                                                                    return <option key={n.notice} value={n.notice}>{ n.name }</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    {
                                                        this.state.errors.find(x => x.field === "noticePeriod") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "noticePeriod").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-field">
                                                    <label>Why do you want to leave your current employment?*</label>
                                                    <textarea
                                                        style={this.state.errors.find(x => x.field === "reasonLeaving") ? fieldBorderError : {}}
                                                        value={ this.state.applicant.reasonLeaving }
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                applicant: {
                                                                    ...this.state.applicant,
                                                                    reasonLeaving: event.target.value
                                                                }
                                                            })
                                                        }}/>
                                                    {
                                                        this.state.errors.find(x => x.field === "reasonLeaving") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "reasonLeaving").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Where did you hear about this position?*</label>
                                                    <div className="select">
                                                        <select
                                                            style={this.state.errors.find(x => x.field === "referral") ? fieldBorderError : {}}
                                                            value={ this.state.applicant.referral }
                                                            onChange={ (event) => { 
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        referral: parseInt(event.target.value)
                                                                    }
                                                                })
                                                            }}
                                                            >
                                                            {
                                                                Constanta.referralOption.map((r,i) => {
                                                                    return <option key={r.referral} value={r.referral}>{ r.name }</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                    {
                                                        this.state.errors.find(x => x.field === "referral") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "referral").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                ( this.state.applicant.referral === Constanta.referral.EMPLOYEE || this.state.applicant.referral === Constanta.referral.OTHER ) &&
                                                <div className="col-xl-6">
                                                    <div className="form-field">
                                                        <label>{ this.state.applicant.referral === Constanta.referral.EMPLOYEE ? "His/Her name*" : "Please describe" }</label>
                                                        <input
                                                            style={this.state.errors.find(x => x.field === "referralOther") ? fieldBorderError : {}}
                                                            value={ this.state.applicant.referralOther }
                                                            onChange={ (event) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        referralOther: event.target.value
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                        {
                                                            this.state.errors.find(x => x.field === "referralOther") &&
                                                            <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "referralOther").error }</span>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Scan / photo of your ID*</label>
                                                    <input
                                                        style={this.state.errors.find(x => x.field === "idFile") ? fieldBorderError : {}}
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                idFile: event.target.files[0]
                                                            })
                                                        }}
                                                        type="file"
                                                        accept="image/png,image/jpeg"/>
                                                    <small>Max size 2Mb. Allowed extentions: .jpg, .jpeg, .png</small><br/>
                                                    {
                                                        this.state.errors.find(x => x.field === "idFile") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "idFile").error }</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="form-field">
                                                    <label>Resume / CV*</label>
                                                    <input
                                                        style={this.state.errors.find(x => x.field === "cvFile") ? fieldBorderError : {}}
                                                        onChange={ (event) => {
                                                            this.setState({
                                                                ...this.state,
                                                                cvFile: event.target.files[0]
                                                            })
                                                        }}
                                                        type="file"
                                                        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"/>
                                                    <small>Max size 2Mb. Allowed extentions: .pdf, .doc, .docx</small><br/>
                                                    {
                                                        this.state.errors.find(x => x.field === "cvFile") &&
                                                        <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "cvFile").error }</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="checkbox">
                                                    <label style={this.state.errors.find(x => x.field === "termsAndConditions") ? fieldBorderError : {}}>
                                                        <input
                                                            type="checkbox"
                                                            value={ this.state.applicant.termsAndConditions }
                                                            checked={ this.state.applicant.termsAndConditions }
                                                            onChange={ (event) => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    applicant: {
                                                                        ...this.state.applicant,
                                                                        termsAndConditions: event.target.checked
                                                                    }
                                                                })
                                                            }}
                                                            />
                                                        I hereby declare that the information provided above is true and correct to the best of my knowledge, and I understand that DevStack has the full right to stop any ongoing recruitment process without further explanation if any of the information above is found to be untrue.
                                                    </label>
                                                </div>
                                                {
                                                    this.state.errors.find(x => x.field === "termsAndConditions") &&
                                                    <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "termsAndConditions").error }</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <ReCAPTCHA
                                                    ref="recaptcha"
                                                    sitekey={ config.reCaptchaSiteKey }
                                                    onChange={ (response) => { this.onCaptchaChange(response) } }/>
                                                {
                                                    this.state.errors.find(x => x.field === "reCaptcha") &&
                                                    <span className="fieldErrorText text-danger font-weight-bold text-capitalize">{ this.state.errors.find(x => x.field === "reCaptcha").error }</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col text-right">
                                                <button type="button" onClick={() => { this.submit() }} className="gs-btn gs-btn-blue" style={{width: "auto"}}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // jobFunctions: state.jobFunctions,
        // jobLocations: state.jobLocations,
        // jobTypes: state.jobTypes,
        vacancyBySlug: state.vacancyBySlug,
        applicant_id: state.applicant_id
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobApply));



// WEBPACK FOOTER //
// ./src/pages/unauth/jobApply.js